import { createFeatureSelector, createSelector } from '@ngrx/store';
import { PLAN_FEATURE_KEY, PlanState } from './plan.reducer';
import { HighlightedDate } from '@lyceo/shared/plan/util-models';

export const selectPlanState =
  createFeatureSelector<PlanState>(PLAN_FEATURE_KEY);

export const selectActiveDate = createSelector(
  selectPlanState,
  (state: PlanState) => state.activeDate,
);

export const selectSelectedDate = createSelector(
  selectPlanState,
  (state: PlanState) => state.selectedDate,
);

export const selectNumberOfWeeks = createSelector(
  selectPlanState,
  (state: PlanState) => state.numberOfWeeks,
);

export const selectPupilContext = createSelector(
  selectPlanState,
  (state: PlanState) => state.pupilContext,
);

export const selectPupilId = createSelector(
  selectPupilContext,
  (pupilContext) => pupilContext?.pupilId,
);

export const selectHasPupilContext = createSelector(
  selectPupilContext,
  (pupilContext) => !!pupilContext,
);

export const selectHighlightedDates = createSelector(
  selectSelectedDate,
  (selectedDate: Date) =>
    [
      {
        date: selectedDate,
        contrast: 'var(--trix-text-color-4)',
        color: 'var(--trix-color-plan-selected)',
        border: '',
      },
      {
        date: new Date(),
        contrast: 'var(--trix-text-color-1)',
        color: 'var(--trix-color-plan-today-light)',
        border: 'var(--trix-color-plan-today-dark)',
      },
    ] as HighlightedDate[],
);
